var renderDeliveryWindow = function renderDeliveryWindow() {
  var _metaEl$getAttribute;
  var userCountry = localStorage.getItem('userCountry');
  var iconEl = document.querySelector('.delivery-window__icon');

  // function to hide the shipping icon
  var hideIcon = function hideIcon() {
    if (iconEl) iconEl.style.display = 'none';
  };
  if (!userCountry) {
    console.warn('was not found "userCountry" in localStorage.');
    hideIcon();
    return;
  }
  var metaEl = document.getElementById('delivery-time-meta');
  if (!metaEl) {
    console.warn('was not found element id "delivery-time-meta".');
    hideIcon();
    return;
  }

  // Nueva condición: si data-title está vacío o no existe
  var dataTitle = metaEl.getAttribute('data-title');
  if (!dataTitle || dataTitle.trim() === '') {
    console.warn(' "data-title" is empty in #delivery-time-meta.');
    hideIcon();
    return;
  }
  var safeParse = function safeParse(val) {
    var parsed = parseInt(val, 10);
    return isNaN(parsed) ? 0 : parsed;
  };
  var printMin = safeParse(metaEl.getAttribute('data-printmin'));
  var printMax = safeParse(metaEl.getAttribute('data-printmax'));
  var perCountry = ((_metaEl$getAttribute = metaEl.getAttribute('data-percountry')) !== null && _metaEl$getAttribute !== void 0 ? _metaEl$getAttribute : 'false').toLowerCase() === 'true';
  var startDays = 0;
  var endDays = 0;
  if (!perCountry) {
    var localMin = safeParse(metaEl.getAttribute('data-localmin'));
    var localMax = safeParse(metaEl.getAttribute('data-localmax'));
    var globalMin = safeParse(metaEl.getAttribute('data-globalmin'));
    var globalMax = safeParse(metaEl.getAttribute('data-globalmax'));
    var isUS = userCountry.trim().toLowerCase() === 'united states';
    if (isUS) {
      startDays = printMin + localMin;
      endDays = printMax + localMax;
    } else {
      startDays = printMin + globalMin;
      endDays = printMax + globalMax;
    }
  } else {
    var deliveryEls = document.querySelectorAll('.delivery-time');
    var countryEl = null;
    deliveryEls.forEach(function (el) {
      var elCountry = el.getAttribute('data-country');
      if (elCountry && elCountry.trim().toLowerCase() === userCountry.trim().toLowerCase()) {
        countryEl = el;
      }
    });
    if (!countryEl) {
      console.warn("was not found .delivery-time for ".concat(userCountry, "."));
      hideIcon();
      return;
    }
    var minDelivery = safeParse(countryEl.getAttribute('data-mindelivery'));
    var maxDelivery = safeParse(countryEl.getAttribute('data-maxdelivery'));
    startDays = printMin + minDelivery;
    endDays = printMax + maxDelivery;
  }
  var today = new Date();
  var startDate = new Date(today.getTime() + startDays * 86400000);
  var endDate = new Date(today.getTime() + endDays * 86400000);
  var formatDate = function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });
  };
  var deliveryText = "Order now and delivers within <span>".concat(formatDate(startDate), " - ").concat(formatDate(endDate), "</span>");
  var windowEl = document.querySelector('.delivery-window__text');
  if (windowEl) {
    windowEl.innerHTML = deliveryText;
  } else {
    console.warn('was not found element ".delivery-window__text".');
  }
};
export { renderDeliveryWindow };